import React, { memo } from 'react';

interface WorkoutControlsProps {
  isRunning: boolean;
  onStartStop: () => void;
  onLap: () => void;
  onComplete: () => void;
  lapNumber?: number;
}

const WorkoutControls: React.FC<WorkoutControlsProps> = memo(
  ({ isRunning, onStartStop, onLap, onComplete, lapNumber = 0 }) => {
    return (
      <div className="workout__controls-container" data-testid="workout-controls">
        <div className="workout__button-row">
          {!isRunning ? (
            <button className="workout__button workout__button--start" onClick={onStartStop}>
              Start Workout
            </button>
          ) : (
            <>
              <button className="workout__button workout__button--lap" onClick={onLap}>
                Lap {lapNumber + 1}
              </button>
              <button className="workout__button workout__button--end" onClick={onComplete}>
                End Workout
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
);

// Add display name
WorkoutControls.displayName = 'WorkoutControls';

export default WorkoutControls;
